import React, { Fragment, useEffect, useState } from "react";
import { Edit } from "react-feather";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";
import axiosInstance from "../../utils/axios";
import { useSelector } from "react-redux";

const Reward_list = () => {
  const navigate = useNavigate();

  const userType = localStorage.getItem("userType");
  const merchantIdFromStorage = localStorage.getItem("MerchantId");
  const { selectedMerchant: reduxSelectedMerchant } = useSelector((state) => state.merchant || {});
  const selectedMerchant = userType === "merchant" ? merchantIdFromStorage : reduxSelectedMerchant;

  const [isFetching, setIsFetching] = useState(false);
  const [rewardData, setRewardData] = useState([]);
  const [displayedRewards, setDisplayedRewards] = useState([]);

  const handleEditClick = (rewardId) => {
    navigate(`/rewards/edit-reward/${rewardId}`);
  };

  const handleCreateNewReward = () => {
    navigate("/rewards/add-reward");
  };

  const fetchRewardList = async () => {
    try {
      setIsFetching(true);
      // const response = await axiosInstance.get("/api/reward/getRewardList:${merchantIdFromStorage}");
      const response = await axiosInstance.get(
        // `/api/reward/getActiveRewardList/${selectedMerchant}`
        `/api/reward/getActiveRewardList`
      );
      console.log("response", response?.data?.data);
      setRewardData(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching rewards:", error.response?.data || error);
      setRewardData([]);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchRewardList();
  }, []);

  useEffect(() => {
    if (selectedMerchant && selectedMerchant !== "all") {
      const filtered = rewardData.filter(r => (r.merchantId || r.MerchantId) == selectedMerchant);
      setDisplayedRewards(filtered);
    } else {
      setDisplayedRewards(rewardData);
    }
  }, [selectedMerchant, rewardData]);

  return (
    <Fragment>
      <Breadcrumb title="Reward List" parent="Rewards" />
      <Container fluid={true}>
        <Row>
          <Col style={{ marginBottom: "30px", display: "flex", justifyContent: "flex-end", gap: "8px" }}>
            <Button
              color="primary"
              style={{
                padding: "10px 20px",
                fontSize: "16px",
                borderRadius: "5px",
                float: "right",
              }}
              onClick={handleCreateNewReward}
            >
              Create New Reward
            </Button>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                {isFetching ? (
                  <div>Loading rewards...</div>
                ) : displayedRewards.length === 0 ? (
                  <div>No rewards found</div>
                ) : (
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Image</th>
                        <th>Name</th>
                        <th>Points</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayedRewards.map((reward, i) => (
                        <tr key={i} style={{ verticalAlign: "middle" }}>
                          <td>{reward?.id}</td>
                          <td>
                            <img
                              alt="reward"
                              src={
                                reward?.image
                                  ? reward.image
                                  : "https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/camera-512.png"
                              }
                              style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "5px",
                              }}
                            />
                          </td>
                          <td>{reward?.Name}</td>
                          <td>{reward?.Points}</td>
                          <td>
                            {reward?.is_active ? (
                              <span style={{ color: "#008000" }}>Active</span>
                            ) : (
                              <span style={{ color: "#ff0000" }}>Inactive</span>
                            )}
                          </td>
                          <td>
                            <Button
                              color="btn"
                              type="button"
                              onClick={() => handleEditClick(reward?.id)}
                            >
                              <Edit
                                className="editBtn"
                                style={{ width: "16px", height: "16px" }}
                              />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Reward_list;